import jsMain from '../../../node_modules/zuru-css/dist/main.bundle';

export default jsMain;
